import React, { useState } from 'react'
import Box from '@mui/material/Box'

import { usePrepareOptimisation } from '../hooks/use-estate'
import CustomButton from './custom-button'

function OptimiseNowButton({
    estateId,
}: {
    estateId: string | number | undefined,
}) {

    const [response, setResponse] = useState<string | null>(null)

    const mutation = usePrepareOptimisation(estateId, setResponse)
    
    return (
        <Box display="flex" flexDirection="column" mt={5}>
            <Box display="flex" justifyContent="center">
                <CustomButton
                    variant="outlined"
                    color="primary"    
                    text="Vytopit na maximum"
                    onClick={() => mutation.mutate()}
                />
            </Box>
            {response &&
                <Box sx={{
                    fontSize: '0.875rem',
                    color: 'primary',
                    textAlign: 'center',
                    marginTop: '1rem',
                }}>{response}</Box>
            }
        </Box>
    )
}

export default OptimiseNowButton
